var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{class:_vm.guideLineClass,attrs:{"data-cy":"受講進捗ガイドライン"}},[_c('v-icon',{attrs:{"icon":"comment"}}),_vm._v(_vm._s(this.guideLine))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }